import { render, staticRenderFns } from "./image-gallery.vue?vue&type=template&id=f5dbf9de&scoped=true"
import script from "./image-gallery.vue?vue&type=script&lang=js"
export * from "./image-gallery.vue?vue&type=script&lang=js"
import style0 from "./image-gallery.vue?vue&type=style&index=0&id=f5dbf9de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5dbf9de",
  null
  
)

export default component.exports